<template>
    <div>

        <config-main-title v-if="!crm">
            Profissionais Solicitantes
        </config-main-title>

        <div class="form-row mb-0">
            <div class="col col-12" :class="crm ? '' : 'col-md-6'">
                <az-input icon="fas fa-search fa-fw" v-model="search" @input="buscarItems ()">
                    <template v-slot:buttonposb>
                        <importacao service="medico_solicitantes" @refresh="load()" v-if="!recepcao && !crm" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-primary" @click="filtro_por_periodo = !filtro_por_periodo; load();">
                                <i class="fa-regular fa-calendar-check"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="!crm">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'; load();">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'; load();">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="!crm">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Profissional
                </button>
            </div>
        </div>

        <div class="form-row mt-2" v-if="filtro_por_periodo">
            <div class="col col-12 col-md-6">
                <az-periodo v-model="filtro" :sync="true" @sync="load()" />
            </div>
            <div class="col col-12 col-md-6">
                <az-input
                    type="select"
                    :optionsList="lista_status"
                    optionsData="id_contato_status"
                    placeholder="Todos os status..."
                    icon="fa fa-filter fa-fw"
                    v-model="filtro.id_contato_status" />
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <table class="table table-sm border-0 table-responsive mb-1">
            <tr>
                <td class="text-nowrap">
                    <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in options_classes" :key="icx">
                        <span class="badge badge-success mr-1" >
                            {{ classe }}
                        </span>
                    </a>
                </td>
            </tr>
        </table>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma profissional identificado.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id"
                    :class="( dado.contato && dado.contato.contato_status && dado.contato.contato_status.st_color ) ? 'list-group-item-' + dado.contato.contato_status.st_color : ''">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <big data-toggle="tooltip" data-placement="top" title="Teto para data futura" 
                            v-if="dado.dt_inicio_vigencia > $util.hoje()">
                            <i class="fas fa-plane-departure mr-2"></i>
                        </big>
                        <big data-toggle="tooltip" data-placement="top" title="Teto com vigência já passada" 
                            v-if="dado.dt_final_vigencia < $util.hoje()">
                            <i class="fas fa-history mr-2"></i>
                        </big>
                        <div v-if="dado.js_classes && dado.js_classes.length">
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in dado.js_classes" :key="icx">
                                <span class="badge badge-success mr-1">
                                    {{ classe }}
                                </span>
                            </a>
                        </div>
                        <div v-if="dado.contato && dado.contato.contato_status" class="small">
                            {{ dado.contato.contato_status.search }}
                        </div>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <a href="#" @click.prevent="filtrar(dado.especialidade.st_codigo_cbo_3)">
                                <span class="badge badge-dark" v-if="dado.especialidade">
                                    {{ dado.especialidade.search }}
                                </span>
                            </a>

                            <button type="button" title="Contatos" class="btn btn-outline-primary btn-sm ml-2" @click="editar_contatos (dado)">
                                <i class="fa-solid fa-comments"></i>
                                <span class="badge badge-primary ml-1" v-if="dado.contatos_count">
                                    {{ dado.contatos_count }}
                                </span>
                            </button>

                            <button type="button" title="Arquivos" class="btn btn-outline-primary btn-sm ml-2" @click="abrir_anexos (dado)">
                                <i class="fa-solid fa-paperclip fa-fw" v-if="dado.arquivos && dado.arquivos.length"></i>
                                <i class="fa-solid fa-plus fa-fw" v-else></i>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

            <template v-if="dados.last_page > 1">
                <nav class="navbar fixed-bottom navbar-light bg-light pb-3">
                    <div class="d-flex">
                        <paginate
                            class="mb-0"
                            :page-count="dados.last_page"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :prev-class="'page-link'"
                            :next-class="'page-link'"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :click-handler="load">
                        </paginate>
                    </div>
                </nav>
            </template>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_medico_solicitante ? '' : 'Novo' }}
                            Profissional Solicitante
                            {{ item && item.id_medico_solicitante ? '#' + item.id_medico_solicitante : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    label="Nome"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    sizing="sm"
                                    label="Especialidade"
                                    type="select" 
                                    service="especialidades.index"
                                    optionsData="id_especialidade"
                                    optionsDisplay="search"
                                    optionsName="esp-todas"
                                    optionsMode="aql"
                                    required
                                    :validate="validate"
                                    v-model="item.id_especialidade">
                                </az-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input label="Conselho" 
                                    sizing="sm"
                                    type="select" 
                                    optionsMode="aql"
                                    service="conselhos.index"
                                    optionsData="id_conselho" 
                                    optionsDisplay="st_sigla"
                                    v-model="item.id_conselho" 
                                    required
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input label="UF" 
                                    sizing="sm"
                                    type="select" 
                                    optionsMode="aql"
                                    service="estados.index"
                                    optionsData="id_estado" 
                                    optionsDisplay="st_estado"
                                    v-model="item.id_estado_conselho" 
                                    required
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Número"
                                    required
                                    :validate="validate"
                                    v-model="item.st_numero_conselho" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input label="CPF" 
                                    sizing="sm"
                                    type="cpf" 
                                    v-model="item.st_cpf"
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Cartão SUS (CNS)"
                                    type="cns"
                                    :validate="validate"
                                    v-model="item.st_sus"
                                    :rules="['size:15']" />
                            </div>
                        </div>

                        <az-sub-title class="mt-2" title="Endereço" />
                        <cadastro-endereco :edicao="true" sizing="sm" v-model="item.endereco" :validate="validate" />

                        <az-sub-title class="mt-2" title="Contato" />
                        <div class="row">
                            <div class="col col-6">
                                <az-input
                                    sizing="sm"
                                    label="Celular"
                                    type="fone"
                                    :validate="validate"
                                    v-model="item.st_celular" />
                            </div>

                            <div class="col col-6">
                                <az-input
                                    sizing="sm"
                                    label="Telefone"
                                    type="fone"
                                    :validate="validate"
                                    v-model="item.st_telefone" />
                            </div>

                            
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="E-mail"
                                    type="email"
                                    :validate="validate"
                                    v-model="item.st_email" />
                            </div>
                        </div>

                        <div v-if="integra_kualiz">
                            <az-sub-title class="mt-2" title="Integração Kualiz" />
                            <div class="row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Id de Origem da Oportunidade"
                                        type="number"
                                        :validate="validate"
                                        v-model="item.st_kualiz_origem" />
                                </div>
                            </div>
                        </div>

                        <div v-if="!crm && item.id_medico_solicitante && item.usuarios">
                            <az-sub-title class="mt-2" title="Usuário do Portal" />

                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(usuario_ms, iux) in item.usuarios" :key="iux">
                                    <div>{{ usuario_ms.st_login }}</div>
                                    <div>
                                        <a href="#" @click.prevent="toggle_user_bloq(usuario_ms)" class="mr-2">
                                            <i class="fa-regular fa-circle text-primary fa-fw" title="Acesso liberado" v-if="!usuario_ms.fl_bloqueado"></i>
                                            <i class="fa-solid fa-ban text-danger fa-fw" title="Acesso bloqueado" v-else></i>
                                        </a>

                                        <a href="#" @click.prevent="redefinir_senha(usuario_ms)" title="Redefinir Senha.">
                                            <i class="fa-solid fa-key fa-fw"></i>
                                        </a>
                                    </div>
                                </li>
                            </ul>

                            <div v-if="!item.usuarios.length">
                                <button type="button" class="btn btn-sm btn-outline-primary" @click="criar_login_medico()">Criar Login</button>
                            </div>

                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div v-if="item.campos_customizados && item.campos_customizados.js_campos.length" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" />
                                <formulario 
                                    :gutters="true" 
                                    v-model="item.campos_customizados.js_campos" 
                                    :saved="true" 
                                    mode="fixed"
                                    :validate="validate"
                                    :config="true" />
                            </div>
                        </div>


                    </div>

                    <div class="modal-footer">
                        <az-audit-log-button model="medicoSolicitante" :id="item.id_medico_solicitante" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_medico_solicitante ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br><br>

        <registrar-contatos 
            :lista_status="lista_status" 
            :extra_parms="{ solicitante: true }"
            ref="regcontatos" 
            @refresh="load()">
            <template v-slot:info>
                <div class="alert alert-info" v-if="edicao">
                    {{ edicao.st_nome }}
                </div>
            </template>
        </registrar-contatos>

        <template v-if="acao_anexar && edicao && edicao.arquivos">
            <az-file-upload
                :tem_validade="true"
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="edicao.arquivos"
                :parms="{ model_type: 'medicoSolicitante', model_id: edicao.id_medico_solicitante }" />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Importacao from '../shared/Importacao.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import Multiselect from 'vue-multiselect';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            pesquisar_debounce: null, 
            options_classes: [],
            edicao: null, 
            lista_status: [], 
            acao_anexar: false,
            integra_kualiz: false, 
            filtro_por_periodo: false, 
            filtro: { 
                periodo: 'm', 
                id_contato_status: "", 
            }
        }
    },

    props: ['cadastro', 'crm'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
        Importacao,
        CadastroEndereco,
        Formulario, 
        Multiselect, 
        RegistrarContatos, 
        AzFileUpload, 
        AzPeriodo,
    },

    computed: { 
        recepcao: function () { 
            return this.$route.name == 'r-medico-solicitante';
        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            return this.dados ? this.dados.data : [];
        },

    },

    methods: { 
        toggle_user_bloq (usuario) { 
            if ( !confirm('Confirma alterar a condição de acesso (bloqueado/liberado)?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'medicos',
                func: 'toggle_usuario_acesso', 
                dados: { 
                    id_medico_solicitante: this.item.id_medico_solicitante, 
                    id_usuario: usuario.id_usuario
                },
                toast: true, 
                callback: res => { 
                    if ( res.usuario ) { 
                        usuario.fl_bloqueado = res.usuario.fl_bloqueado;
                    }
                }
            });

        },

        carregar_arquivos(abrir = false) {
            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.edicao.id_medico_solicitante,
                    type: 'medicoSolicitante',
                }
            })
            .then(res => {
                this.edicao.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },

        abrir_anexos (item) {
            this.acao_anexar = true;

            this.edicao = _.cloneDeep(item);

            if ( this.edicao.arquivos && this.edicao.arquivos.length
                && !this.edicao.arquivos.find(arq => arq.arquivo) ) {

                this.carregar_arquivos(true);
                return;

            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        editar_contatos (item) { 
            this.$util.load(this, { 
                service: 'medico_solicitantes', 
                func: 'show',
                parms: { 
                    id: item.id_medico_solicitante,
                    contatos: true, 
                },
                loadTo: res => { 

                    this.edicao = res;

                    this.edicao.model = { 
                        type: 'medicoSolicitante',
                        id: item.id_medico_solicitante, 
                    };

                    this.$refs.regcontatos.editar(this.edicao);        

                }
            });
        },

        filtrar(texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        redefinir_senha (usuario) { 
            if ( this.$store.state.loading ) { 
                return;
            }

            if ( !confirm('Confirma redefinir a senha do profissional Solicitante?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'medicos',
                func: 'resetar_senha_login_portal', 
                dados: { 
                    id_medico_solicitante: this.item.id_medico_solicitante, 
                    id_usuario: usuario.id_usuario
                },
                callback: res => { 
                    alert('Nova Senha: ' + res.senha);

                    if ( res.usuario ) { 
                        usuario.fl_bloqueado = res.usuario.fl_bloqueado;
                    }
                }
            });
        },

        criar_login_medico () { 
            if ( this.$store.state.loading ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'medicos',
                func: 'criar_login_portal', 
                dados: { 
                    id_medico_solicitante: this.item.id_medico_solicitante 
                },
                modal: 'edicaoModal',
                callback: res => { 
                    alert('Senha: ' + res.senha);
                    this.load();
                }
            });
        },

        buscarItems () { 
            if ( this.pesquisar_debounce )
                clearTimeout(this.pesquisar_debounce);

            this.pesquisar_debounce = setTimeout(() => {
                this.load();
                clearTimeout(this.timeout);
            }, 1000);
        },
        
        incluir () { 
            this.validate = false;

            let item = {
                id_medico_solicitante: null, 
                st_nome: "",
                id_conselho: "", 
                id_estado_conselho: "", 
                id_especialidade: "", 
                fl_ativo: true, 
            };

            this.editar (item);
        },

        load (page = 1) { 
            this.$util.load(this, { 
                service:'medico_solicitantes',
                func: 'index',
                parms: { 
                    size: 30, 
                    page: page, 
                    cadastro: true, 
                    search: this.search, 
                    view_mode: this.viewMode, 
                    recepcao: this.recepcao, 
                    filtro_por_periodo: this.filtro_por_periodo, 
                    ...this.filtro,
                },
                configs: ['integrar-crm-kualiz-automatico-fila'],
                loadTo: res => { 
                    this.dados = res;
                    if ( page > 1 && res.last_page < page ) { 
                        this.load(1);
                    }

                    if ( this.$store.state.contexto['integrar-crm-kualiz-automatico-fila'] > 0 ) { 
                        this.integra_kualiz = true; 
                    }
                }
            });
        },

        editar (item) { 
            this.validate = false;

            if ( item.id_medico_solicitante ) { 

                this.$util.load(this, { 
                    service: 'medico_solicitantes', 
                    func: 'show',
                    parms: { 
                        id: item.id_medico_solicitante,
                        cadastro: true, 
                    },
                    loadTo: res => { 

                        if(!res.endereco) {
                            res.endereco = {}
                        }

                        this.item = res;

                        $('#edicaoModal').modal('show');

                    }
                });

            } else { 

                this.item = _.cloneDeep (item);

                if(!this.item.endereco) {
                    this.item.endereco = {}
                }

                $('#edicaoModal').modal('show');

            }
            
        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'medico_solicitantes',
                dados: { 
                    ...this.item,
                    cadastro: true, 
                    recepcao: this.recepcao, 
                },
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'medico_solicitantes',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        if ( this.recepcao ) { 
            this.breadcrumb = [
                { name: "Recepção", path: "/recepcao"},
                { name: "Profissionais Solicitantes", method: this.fechar },
            ];    
        } else if ( this.crm ) { 
            this.breadcrumb = [
                { name: "CRM", path: "/crm"},
                { name: "Relacionamento", path: '/crm/relacionamento' },
            ];    
        } else { 
            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Profissionais Solicitantes", method: this.fechar },
                ];
        }

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'medico_solicitantes',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        this.$util.loadItem(this, { 
            service: 'medico_solicitantes',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        //

        this.$util.loadItem(this, { 
            service: 'contato_status',
            func: 'index',
            parms: { 
                model: 'medicoSolicitante'
            },
        })
        .then(res => {

            this.lista_status = res;
        
            if ( this.lista_status ) { 
                this.lista_status.push({ 
                    id_contato_status: 'R',
                    st_contato_status: 'Registrado',
                    search: 'Registrado',
                });
            }

        });


    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>